import React from "react";

const AdminNewTicketEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">New Ticket Requires Your Attention</h2>
                    <p class="text-gray-700 mb-6">A new service desk ticket has been submitted and is awaiting assignment. Please review the details below and assign it to an appropriate team member.</p>
                    
                    <div class="border-l-4 p-4 mb-4 bg-amber-50 border-amber-200 text-amber-800">
                        <p class="font-semibold mb-1">Action Required — Unassigned Ticket</p>
                        <p class="text-sm">This ticket has not yet been assigned. SLA clock is running.</p>
                    </div>

                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Submitted By:</span>
                            <span class="text-gray-900">Sarah Mitchell (sarah.mitchell@company.com)</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Department:</span>
                            <span class="text-gray-900">Sales Operations</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Priority:</span>
                            <span class="text-gray-900"><span class="inline-block bg-orange-100 text-orange-800 px-2 py-1 rounded text-sm font-medium">High</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Status:</span>
                            <span class="text-gray-900"><span class="inline-block bg-gray-100 text-gray-700 px-2 py-1 rounded text-sm font-medium">To Do</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">SLA Target:</span>
                            <span class="text-gray-900">Response within 4 hours · Resolution within 8 hours</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">SLA Deadline:</span>
                            <span class="text-gray-900"><span class="text-red-700 font-medium">May 6, 2026 at 6:30 PM</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Submitted:</span>
                            <span class="text-gray-900">May 6, 2026 at 2:30 PM</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Attachments:</span>
                            <span class="text-gray-900">2 files (screenshot.png, error-log.txt)</span>
                        </div>
                    </div>

                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">User's Description:</h3>
                        <div class="bg-gray-50 p-4 rounded border border-gray-200">
                            <p class="text-gray-700 text-sm">I'm unable to connect to the customer database since this morning. When I try to log in, I receive an "Authentication failed" error. This is blocking my ability to process customer orders.</p>
                        </div>
                    </div>

                    <div class="mb-6 bg-amber-50 border border-amber-200 rounded-md p-4">
                        <h3 class="font-semibold text-amber-900 mb-2">Recommended Next Steps:</h3>
                        <ol class="list-decimal list-inside text-sm text-amber-800 space-y-1">
                            <li>Review the ticket details and attached files</li>
                            <li>Assign to the appropriate team member or queue</li>
                            <li>Ensure the response SLA is met before the deadline</li>
                        </ol>
                    </div>

                    <div class="flex gap-3 flex-wrap">
                        <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">Review & Assign Ticket</a>
                        <a href="#" class="inline-block bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">View All Unassigned Tickets</a>
                    </div>

                    <div class="mt-6 pt-6 border-t border-gray-200">
                        <p class="text-sm text-gray-600">You are receiving this notification as a Service Desk Administrator. To manage your notification preferences, visit your account settings.</p>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;

    return (
        <div className="p-4">
            <h1 className="text-xl font-bold mb-4">Email Template Preview: New Ticket Attention</h1>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
    );
};

export default AdminNewTicketEmail;
